export default __webpack_public_path__ + "static/media/2442.40eb4e64.jpg";